import { EBlockType } from "@project/shared-types";
import { Faq } from "../faq/faq";
import { NewPayment } from "../NewPayment/NewPayment";
import { BigBlock } from "./BigBlock";
import { How } from "./How";
import { MainBlock } from "./MainBlock";
import { MiddleBlock } from "./MiddleBlock";
import { SmallBlock } from "./SmallBlock";
import { TwoText } from "./TwoText";

export const BLOCKS: Record<string, React.ComponentType<any>> = {
  [EBlockType.UMAIN]: MainBlock,
  [EBlockType.UFASTPAYMENT]: NewPayment,
  [EBlockType.UHOW]: How,
  [EBlockType.BIGTEXT]: BigBlock,
  [EBlockType.MIDDLETEXT]: MiddleBlock,
  [EBlockType.SMALLTEXT]: SmallBlock,
  [EBlockType.TWOTEXTS]: TwoText,
  [EBlockType.FAQ]: Faq,
};
